import { render, staticRenderFns } from "./ScheduleTimeslots.vue?vue&type=template&id=fa4a018a&scoped=true&"
import script from "./ScheduleTimeslots.vue?vue&type=script&lang=js&"
export * from "./ScheduleTimeslots.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleTimeslots.vue?vue&type=style&index=0&id=fa4a018a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4a018a",
  null
  
)

export default component.exports